import React from "react";
import styled from "styled-components";
import { Link } from "@reach/router";
import Logo from "../assets/and-digital.png";
import { tablet, mobile } from "../responsive";
const StyledNav = styled.div`
  background-color: #323232;
  color: white;
  padding: 1rem 2.5rem;
  height: 7vh;

  ${tablet({ fontSize: "0.8rem", padding: "0.5rem", height: "6vh" })}
  ${mobile({ fontSize: "0.7rem" })}

  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${tablet({ paddingTop: "0.5rem" })}

    .links {
      display: flex;
      column-gap: 0.5rem;
    }
    li:not(.club) {
      transition: all 0.2s ease-in-out;
      &:hover {
        text-decoration: underline;
      }
    }
    .club-name {
      font-family: "Poppins";
      display: flex;
      align-items: center;
      column-gap: 0.3rem;

      img {
        height: 1.5rem;
        ${tablet({ height: "1rem" })}
      }
    }
    column-gap: 0.5rem;
  }
`;
function Nav({ setLoggedIn }) {
  const club = window.localStorage.getItem("club");

  return (
    <StyledNav>
      <ul>
        <Link to={`/`}>
          <div className="club-name">
            <img alt="AND Digital Logo" src={Logo} />{" "}
            <li className="club">{club}</li>
          </div>
        </Link>
        <div className="links">
          <Link to={`/`}>
            <li>Projects</li>
          </Link>
          <Link to={`/create-client`}>
            <li>Create New Project</li>
          </Link>
          <Link to={"/help-and-resources"}>
            <li>Help</li>
          </Link>
          <Link
            onClick={() => {
              window.localStorage.clear();
              setLoggedIn(false);
            }}
            to={"/"}
          >
            <li>Log Out</li>
          </Link>
        </div>
      </ul>
    </StyledNav>
  );
}

export default Nav;
